import { VProgressCircular } from 'vuetify/lib'
import { mapGetters } from 'vuex'

/**
 *  A map of wrapper types props, so we can handle complex props combination
 *  by passing a single prop "wrapperType" to the target
 */
const wrapperTypesMap = {
  card: {
    color: 'primary',
    indeterminate: true,
    style: `
      position: absolute;
      margin: auto;
      z-index: 1;
      inset: 0;
    `
  },
  expansionPanel: {
    color: 'primary',
    indeterminate: true
  }
}

export default {
  inheritAttrs: false,
  props: {
    wrapperType: String
  },
  components: {
    VProgressCircular
    // we can register and use other kind of loaders here
  },
  computed: {
    ...mapGetters({
      'loadingFeedback': 'userDataStore/loadingFeedback'
    }),
    classes () {
      return ''
    },

    commonAttrs () {
      const wrapperTypeProps = wrapperTypesMap[this.wrapperType] || {}
      return {
        ...wrapperTypeProps
      }
    },

    overrideAttrs () {
      return {
      }
    }
  }
}
